import { default as indexYcZvAZ0CZVMeta } from "/home/raci_app/apps/default/pages/index.vue?macro=true";
import { default as projects8llj1O1cwXMeta } from "/home/raci_app/apps/default/pages/projects.vue?macro=true";
import { default as _91project_id_93_45_91category_id_93_45_91role_id_93KfzZ0TPVx1Meta } from "/home/raci_app/apps/default/pages/roles/[project_id]-[category_id]-[role_id].vue?macro=true";
import { default as setupyGHR2cPcujMeta } from "/home/raci_app/apps/default/pages/setup.vue?macro=true";
import { default as user_45not_45foundY3gteStn78Meta } from "/home/raci_app/apps/default/pages/user-not-found.vue?macro=true";
import { default as users_45per_45projectNAy2SfNcpMMeta } from "/home/raci_app/apps/default/pages/users-per-project.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/raci_app/apps/default/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "projects",
    path: "/projects",
    component: () => import("/home/raci_app/apps/default/pages/projects.vue").then(m => m.default || m)
  },
  {
    name: "roles-project_id-category_id-role_id",
    path: "/roles/:project_id()-:category_id()-:role_id()",
    component: () => import("/home/raci_app/apps/default/pages/roles/[project_id]-[category_id]-[role_id].vue").then(m => m.default || m)
  },
  {
    name: "setup",
    path: "/setup",
    component: () => import("/home/raci_app/apps/default/pages/setup.vue").then(m => m.default || m)
  },
  {
    name: "user-not-found",
    path: "/user-not-found",
    component: () => import("/home/raci_app/apps/default/pages/user-not-found.vue").then(m => m.default || m)
  },
  {
    name: "users-per-project",
    path: "/users-per-project",
    component: () => import("/home/raci_app/apps/default/pages/users-per-project.vue").then(m => m.default || m)
  }
]